import { makeStyles } from 'tss-react/mui';
var getBorderStyle = function (error, theme, isOldStyle) {
    if (error) {
        return "1px solid ".concat(theme.palette.customColor.error);
    }
    else if (isOldStyle) {
        return 'none';
    }
    else {
        return "1px solid ".concat(theme.palette.customColor.borderGrey);
    }
};
export var autoCompleteSearchStyle = makeStyles()(function (theme, _a) {
    var _b;
    var isOldStyle = _a.isOldStyle, error = _a.error;
    return ({
        root: {
            border: "1px solid ".concat(theme.palette.customColor.borderGrey),
            overflow: 'hidden',
            borderRadius: 8,
            backgroundColor: theme.palette.common.white,
            minWidth: '270px',
            height: '35px',
            padding: isOldStyle ? '2.5px 0' : 'initial',
        },
        inputRoot: {
            '& input::placeholder': {
                color: (_b = theme.palette.customColor) === null || _b === void 0 ? void 0 : _b.black,
                opacity: 1,
            },
            paddingLeft: '15px',
        },
        popupIndicator: {
            color: theme.palette.customColor.primaryLight,
            marginRight: 2,
        },
        popper: {
            marginTop: '1px !important',
            minHeight: '80px !important',
        },
        popperDisablePortal: {
            position: 'relative',
        },
    });
});
